export function joinAbsRoute(...args: (string | undefined)[]) {
  return `/${args.join('/')}`
}

export function joinRelRoute(...args: (string | undefined)[]) {
  return args.join('/')
}
